import * as React from 'react';

import {
  QRCodeContainer,
  QRCodeTitleContainer,
  QRCodeTitleRedesign,
  QrDivider,
  StyledQRCode,
  StyledQRSkeleton,
} from 'pages/loyalty/loyalty-in-restaurant-redemption/loyalty-in-restaurant-redemption.styled';
import { useLoyaltyMyCode } from 'pages/loyalty/loyalty-in-restaurant-redemption/use-loyalty-my-code';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLoyaltyUserId } from 'state/loyalty/hooks/use-loyalty-user';
import { primitive } from 'styles/constants/primitives';

export const LoyaltyQrCodeLoyaltyIdWidgetRedesign: React.FC = () => {
  const enableQrCodeLoyaltyIdFlag = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_QR_CODE_LOYALTY_ID);

  const { loyaltyUserId } = useLoyaltyUserId();
  const { loading, data } = useLoyaltyMyCode();
  const barcodeOptions = {
    margin: 1,
    scale: 6,
    color: {
      dark: primitive.$black,
      light: primitive.$white,
    },
  };

  if (!enableQrCodeLoyaltyIdFlag) {
    return null;
  }

  const qRCodeTitle = data?.myCodeQrHeading?.locale;

  return (
    <QRCodeContainer>
      <QrDivider></QrDivider>
      {!loading && (
        <QRCodeTitleContainer>
          <QRCodeTitleRedesign content={qRCodeTitle} />
        </QRCodeTitleContainer>
      )}

      <StyledQRSkeleton isLoaded={!!loyaltyUserId}>
        <StyledQRCode
          testID="redemption-qr-code"
          barcode={loyaltyUserId || ''}
          options={barcodeOptions}
        />
      </StyledQRSkeleton>
    </QRCodeContainer>
  );
};
